import { Component, Input, OnInit, AfterContentInit, AfterContentChecked } from '@angular/core';
import { ActivatedRoute, Params} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';

import { ConfigService } from './config.service';
import { ContentService } from './content.service';
import { MetaService } from './meta.service';
import { IntlService } from '../shared/intl.service';
import { LoadingPage } from '../shared/loading-indicator';

import { prebootComplete } from "angular2-universal";

export class Content extends LoadingPage implements OnInit, AfterContentChecked {

    public type: string;
    public currentLanguage: string;
    public content: any;
    public contentAsync: Observable<Object>;

    constructor(public config: ConfigService, public intl: IntlService, private metaService: MetaService, private contentService: ContentService, public route: ActivatedRoute) {
        super(true); // sets loading to true
    }

    public setMeta(){
        let title = this.content.title;
        if(this.content.title[this.currentLanguage]!=null)
            title = this.content.title[this.currentLanguage]
        this.metaService.setMeta('Forgotten Records | ' + title, title, 'xxx');
    }

    ngOnInit(){
        this.setContent();
        // manual preboot in order to avoid the flickering when the client side view kicks in over the server view
        // we wait till the asyn data is available to do the replacement
        if (typeof prebootComplete != 'undefined') {
          prebootComplete();
        }    
    }

    public setContent(){
        this.route.params
            .switchMap((params: Params) => this.contentService.getContent(this.type, {url: params['url']}))
            .subscribe(response => {
                this.content = response;
                // Retrieve language from parent route
                this.route.parent.params.subscribe(
                    (params: Params) => {
                        this.currentLanguage = params['lg'];
                        this.setMeta();
                    }
                );
                
            });
    }

    public getIntlInitObject(){
        let obj: Object = {};
        for(let lg of this.config.data.APP.LANGUAGES.SUPPORTED)
            obj[lg] = '';
        return obj;
    }

    public setType(type: string){
        this.type = type;
    } 

    public setContentAsync(){
        this.contentAsync = this.route.params.switchMap((params: Params) => 
            this.contentService.getContent(this.type, {url: params['url']}))
        if (typeof prebootComplete != 'undefined') {
          prebootComplete();
        }  
    }

    public setContentByIdAsync(){
        this.contentAsync = this.route.params.switchMap((params: Params) => 
            this.contentService.getContent(this.type, {_id: params['id']})
        );
        if (typeof prebootComplete != 'undefined') {
          prebootComplete();
        }  
    }

    // Also set the current language
    public setCurrentLanguage(){
        // Language is made available by the root parent route
        this.route.parent.params.subscribe(
            (params: Params) => {
                this.currentLanguage = params['lg'];
                this.metaService.setLanguage(this.currentLanguage);
            }
        );
    }

    ngAfterContentChecked(){
        if(!this.currentLanguage){
            this.currentLanguage = this.config.data.APP.LANGUAGES.PREFERRED;
            // Meta language
            this.metaService.setLanguage(this.currentLanguage);
        }     
    }
    
} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/content.ts